


































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import EstimateExpenseSummary, {
  EstimateExpense
} from "../../../usecases/orders/estimate-expense-summary";
import Decimal from "decimal.js";

@Component({})
export default class EstimateSummary extends Vue {
  @Prop({ required: true }) estimateSummary!: EstimateExpenseSummary;

  excludedTax: boolean = false;

  formatCurrency(value: number): string {
    return "￥" + value.toLocaleString();
  }

  formatCell(value: number): string {
    if (value === 0) {
      return "";
    }
    return this.formatCurrency(value);
  }

  getExpenseEstimateTotal(): number {
    let result = this.estimateSummary.estimates.reduce(
      (sum, item) => sum + this.getExpenseEstimate(item),
      0
    );
    result += this.estimateSummary.invoices.reduce(
      (sum, item) => sum + this.getExpenseEstimate(item),
      0
    );
    return result;
  }

  getExpensePurchaseTotal(): number {
    let result = this.estimateSummary.estimates.reduce(
      (sum, item) => sum + this.getExpensePurchase(item),
      0
    );
    result += this.estimateSummary.invoices.reduce(
      (sum, item) => sum + this.getExpensePurchase(item),
      0
    );
    return result;
  }

  getExpenseInvoiceTotal(): number {
    let result = this.estimateSummary.estimates.reduce(
      (sum, item) => sum + this.getExpenseInvoice(item),
      0
    );
    result += this.estimateSummary.invoices.reduce(
      (sum, item) => sum + this.getExpenseInvoice(item),
      0
    );
    return result;
  }

  getPendingOrderTotal() {
    return this.estimateSummary.estimates.reduce(
      (sum, item) => sum + this.getPendingOrder(item),
      0
    );
  }

  getUnpaidAmount(): number {
    return this.getExpenseEstimateTotal() - this.getExpenseInvoiceTotal();
  }

  getProfitAmount(): number {
    return this.getExpenseInvoiceTotal() - this.getExpensePurchaseTotal();
  }

  getProfitMargin(): string {
    const total = this.getExpenseEstimateTotal();
    if (total === 0) {
      return "0.00%";
    }
    const profitMargin = Math.ceil(
      new Decimal(this.getProfitAmount())
        .div(total)
        .times(10000)
        .toNumber()
    );
    return (
      new Decimal(profitMargin)
        .div(100)
        .toNumber()
        .toFixed(2) + "%"
    );
  }

  getExpenseEstimate(item: EstimateExpense): number {
    return this.excludedTax ? item.estimate : item.estimateWithTax;
  }

  getExpensePurchase(item: EstimateExpense): number {
    return this.excludedTax ? item.purchase : item.purchaseWithTax;
  }

  getExpenseInvoice(item: EstimateExpense): number {
    return this.excludedTax ? item.invoice : item.invoiceWithTax;
  }

  calculate(isChecked: boolean) {
    this.excludedTax = isChecked;
  }

  getPendingOrder(item: EstimateExpense): number {
    return this.excludedTax ? item.pendingOrderWithoutTax : item.pendingOrder;
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
